import React from 'react';
import { TIconProps } from 'pages/ExperienceCanvas/assets/types';

function CompletedStatusIcon({ fill = '#00AB50', className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      focusable={false}
    >
      <path
        d="M8 1.33333C4.32 1.33333 1.33333 4.32 1.33333 8C1.33333 11.68 4.32 14.6667 8 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8C14.6667 4.32 11.68 1.33333 8 1.33333ZM10.6867 6.80001L7.57332 9.90666C7.47999 10.0067 7.35332 10.0533 7.21999 10.0533C7.09332 10.0533 6.96666 10.0067 6.86666 9.90666L5.31333 8.35335C5.12 8.16002 5.12 7.83998 5.31333 7.64665C5.50667 7.45331 5.82667 7.45331 6.02 7.64665L7.21999 8.84668L9.98 6.09334C10.1733 5.89334 10.4933 5.89334 10.6867 6.09334C10.88 6.28668 10.88 6.60001 10.6867 6.80001Z"
        fill={fill}
      />
    </svg>
  );
}

export default CompletedStatusIcon;
